<template>
  <div>
    <!--填写完成-->
    <div class="statusBar" v-if="tabLabel>1||formData.meeting_need.length>0">
      <ul class="fillin">
          <li class="complete"  :class="{'text-active':tabLabel==1}">
              <div @click="switchNeeds(1)" class="content">
                <div> 入住信息</div>
                <div class="text-success"><i class="el-icon-caret-bottom ml-2"></i></div>
              </div>
          </li>
          <li class="complete" :class="{'text-active':tabLabel==2}">
              <div @click="switchNeeds(2)" class="content">
                <div> 会议需求</div>
                <div><i class="el-icon-caret-bottom ml-2"></i></div>
              </div>
          </li>
          <li class="complete"  :class="{'text-active':tabLabel==3}"  v-if="requirementList[0].state">
              <el-popconfirm
                  placement="top"
                  title="是否删除附加需求？"
                  @confirm="requirementList[0].state=false;formData.add_need=[]"
                >
                  
                  <i class="el-icon-delete-solid "  slot="reference"></i>
              </el-popconfirm>
              <div @click="switchNeeds(3)" class="content">
                <div> 附加需求<span class="text-ris"></span></div>
                <i class="el-icon-caret-bottom ml-2"></i>
              </div>
          </li>
      </ul>
    </div>
    <!-- 基本信息-入住需求-->
    <roomBasic  :ruleForm="formData" v-show="tabLabel===1"  :modify="modify" ref="roomBasic" :isHotelInquiry="isHotelInquiry"></roomBasic>
    <!--会议需求-->
    <meetingType v-show="tabLabel===2" class=" mt-3" :meeting_need="formData.meeting_need" :modify="modify"  ref="meetingType"></meetingType>
    <!--其他需求-->
    <other v-show="tabLabel===3" :add_need="formData.add_need" class=" mt-3" ref="other"></other>
    <!--其他需求开关-->
    <div class="other" v-if="tabLabel>1">
        <p>其他需求</p>
        <ul class="other-list">
          <template v-for="(item,index) in requirementList">
            <li v-if="modify?index>-1:index<1"  :key="item.id" :class="{'other-active':item.state}" @click="switchTabOther(index,item.tabLabel)">{{item.name}}</li>
          </template>
        </ul>
    </div>
    <!--确认发布订单-->
    <div class="room-type-footer mt-4 ">
      <template v-if="tabLabel===1&&formData.meeting_need.length==0">
        <el-button type="primary" @click="roomBasicBottom()" style="width: 100%;">下一步、填写会议需求</el-button>
      </template>
      <el-button style="box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18)" @click="$router.go(-1)" :style="modify&&!orderConfirm?'width:100%':'width:49%'" v-if="tabLabel==1&&formData.meeting_need.length>0" >返回</el-button>
      <template v-if="tabLabel>1">
        <!-- <el-button @click="back()">返回修改</el-button> -->
        <el-button type="primary" @click="submitForm()" style="width: 100%;">确认订单</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import roomBasic from './Components/roomBasic.vue';
import meetingType from './Components/meetingType.vue'             //会议需求
import other from './Components/other.vue'                         //其他需求
export default {
  name: 'Meeting',
  components: {roomBasic, meetingType,other},
  props: {
    //订单详情
    orderDetail: {
      type: Object,
      default: () => {}
    },
    //是否修改订单
    modify: {
      type: Boolean,
      default: false
    },
    //是否询价酒店
    isHotelInquiry: {
      type: Boolean,
      default: false
    },
    //是否是代订收款
    behalf: {
      type: Number,
      default: 0
    }
  },
  mounted() {},
  data() {
    return {
        orderInfo:{},                                    //修改原生数据
        tabLabel: 1,                                //标签页：1入住需求、2房型需求
        formData:{
            order_type: 2,                            //订单类型：1住宿订单、2纯会议订单
            team_type: 2,                             //团队类型：1旅游团、2会议团
            title: '',                                //团号标题
            province:'',                              //目的地省份
            city:'',                                  //目的地城市
            district:[],                                //目的地区县
            star:[],                                  //酒店星级
            meeting_need: [],                         //会议需求
            other:[],                                 //其他需求
            remark:'',                                //备注
            add_need:[],                              //附加需求
        },
        requirementList:[                           //其他需求分类
          {name:'附加需求',text:'添加会场费、餐费、其他',onText:'是否删除附加需求',state:false,tabLabel:4},
        ],   
    };
  },
  computed: {},
  watch: {
    orderDetail: {
      handler(newVal, oldVal) {
        this.initModifyOrder(newVal);
      },
      deep: true
    },
  },
  created() {},
  mounted() {},
  methods: {
    //提交表单
    async submitForm(e) {
      //已填写完基本信息切换房型需求
      let isSubmit = await this.validateForm();

      //修改时多判断一个优惠房
      if(this.modify||this.orderConfirmSend){
        // 对比原始数据和当前数据是否有变化
        let ComparativeData = {...this.formData,...isSubmit};
        const isModify = this.$_Array.deepEqual(this.orderInfo, ComparativeData);
        if(isModify&&this.behalf==0){
          this.$message({
            message: '您未修改任何内容',
            type: 'warning'
          });
          return;
        }
      }
      //代订收款如果有未修改的内容、弹出确认框
      if(this.behalf>0){
          this._confirm('您未修改任何内容，是否确认订单？',() => {
              this.formData = {...this.formData,...isSubmit};
              this.$emit('submitForm',this.formData);
          }); 
          return 
      }
      //确认订单弹出确认框
      if(isSubmit){
        this.formData = {...this.formData,...isSubmit};
        this.$emit('submitForm',this.formData);
      }
    },
    //修改订单初始化
    initModifyOrder(res){
      res=JSON.parse(JSON.stringify(res));       //防止连带
      let Value=this.$_Object.getSecondObjIntersectionValues(this.formData,res);       //只获取交集对象
      Value = this.$_Object.convertCommaValueToArray(Value, false, true);              //带','转为数组
      // 需要转数字的字段数组
      const numKeys = ['order_type', 'city', 'province', 'breakfast']
      numKeys.forEach(key => Value[key] = Number(Value[key]));
      //时间变转毫秒级
      if(res.meeting_need_arr.list){
       res.meeting_need_arr=res.meeting_need_arr.list.map(user=>{
        return{
          ...user,
          date:user.date*1000
        }
      });
      }
      Value={
        ...this.formData,
        ...Value,
        order_type:2,
        team_type:2,                                                          //订单类型             
        district:this.$_Array.commaStrToArray(Value.district)||[],             //区转为数组、方便确认单
        star:this.$_Array.commaStrToArray(Value.star)||[],                     //星级转为数组、方便确认单
        other:this.$_Array.commaStrToArray(Value.other)||[],                   //其他需求转为数组、方便确认单
        meeting_need:res.meeting_need_arr,                                     //会议需求
        add_need:res.add_need_arr.list||[],                                    //附加需求
        room_need_arr:[],
      }
      this.formData = Value;      //赋值给表单数据
      this.orderInfo=JSON.parse(JSON.stringify(Value));       //防止连带-修改原生数据
    },
    //*****************确认订单方法*****************//
    //调用基本信息确认方法
    async roomBasicBottom(){
      let {isSubmit,formData} = await this.$refs.roomBasic.submitForm();       //调用基本信息确认方法
      this.formData = {...this.formData,...formData};
      if(isSubmit){
        this.tabLabel = 2;
      }
    },
    //切换其他需求
    async switchNeeds(i){
      //判断当前房型是全部填完
      let isSubmit = await this.validateForm(i);
      console.log(isSubmit);
      if(isSubmit){
        this.tabLabel = i;
      }
    },
    //点击其他需求
    switchTabOther(index,tabLabel){
      this.requirementList[index].state=true;
    },
    //验证填写表单
    async validateForm(i){
      let isSubmit = await this.isSubmitForm();
      if(this.tabLabel===2&&isSubmit.meeting_need&&isSubmit.meeting_need.length==0){
        this.$message.error('请添加一个会议需求');
        return false;
      };
      if(!isSubmit){
        return isSubmit;
      }
      this.formData = {...this.formData,...isSubmit};
      return i?true:isSubmit;
    },
    //判断当前需求是否填写完整  
    async isSubmitForm(){
      if(this.tabLabel===1){
        let {isSubmit,formData} = await this.$refs.roomBasic.submitForm();       //调用基本信息确认方法
        if(isSubmit){ this.formData = {...this.formData,...formData}}
        return isSubmit
      }
      if(this.tabLabel===2){
        return this.$refs.meetingType.submitForm();
      }
      if(this.tabLabel===3){
        return this.$refs.other.submitForm();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
    .statusBar{
      margin-top: 16px;
    }
    .complete{
        width: 94%;
        display: flex;
        justify-content: space-between;
        margin-right: 16px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        >i{
          color: #999;
          font-size: 16px;
          margin-left: auto !important;
          display: inline-block;
        }
    }
    .room-Type{
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        width: 94%;
        padding: 3%;
        border-radius: 6px;
    }
    .text-ris{
      color: #999;
      margin-left: 12px;
    }
    .fillin{
      display: flex;
      justify-content:space-between;
      li{
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        border-radius: 6px;
      }
      li:last-child {
        margin-right: 0;
        border-right: 0;
      }
      
    }
    .fillin .text-active{
       background-color: var(--smtc-color-primary);
       color: #fff;
       i{
        color:#fff;
        font-size: 16px;
       }
    }
    .room-bottom{
      width: 96%;
      padding: 2%;
      position: sticky;
      bottom: 0;
      left: 0 ;
      z-index: 9;
    }
    .content{
      display: flex;
      width: 100%;
      padding: 16px 4%;
      justify-content: space-between;
    }
    .category-item-icon{
      position: absolute;
      right: -20px;
      bottom: -20px;
      background-color: red;
      width: 40px;
      height: 40px;
      transform: rotate(45deg);
      z-index: 3;
      i{
        margin-left: -27px;
        margin-top: 13px;
        transform: rotate(-45deg);  
        font-size: 12px;
        font-weight: bold;
        color: #fff;
      }
    }
    .other{
            background-color: #fff;
            box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
            width: 94%;
            padding: 2% 3%;
            display: flex;
            justify-content: left;
            margin-top: 20px;
    }
    .other p{
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .other-list{
        display: flex;
        li{
            margin-left: 14px;
            border: 1px dashed #999;
            padding: 4px 10px;
            font-size: 12px;
            border-radius: 4px;
            cursor: pointer;
        }
        .other-active{
            background-color: var(--smtc-color-primary);
            color: #fff;    
            border:1px solid var(--smtc-color-primary);
        }
    }
    .el-icon-delete-solid{
      color: red;
      margin-left: 14px;
      margin-top: 20px;
    }
</style>